module.exports = __webpack_public_path__ + "static/img/14bg_5.0b35917.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/14bg_5.png
// module id = 647
// module chunks = 1